const FORM_VIEW = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
};

const LOCATIONS_FORM_VIEW = {
  DETAILS: 1,
  SERVICEAREA: 2,
  SKILLS: 3,
  SETUP: 4,
  SYSTEM_SETTINGS: 5,
  PERFORMANCE: 6,
  AVAILABILITY: 7,
};

const SYSTEM_SETTING_FORM_VIEW = {
  CLAIMS: 1,
  DISPATCH: 2,
  INSIGHT: 3,
  APIKEY: 4,
};

const AVAILABILITY_FORM_VIEW = {
  LIVE_CALENDAR: 1,
  DEFAULT_SCHEDULES: 2,
  SPECIAL_SCHEDULES: 3,
};

/** Ordered views used by System Settings (service provider or location). Pass a subset to show fewer tabs. */
const DEFAULT_SYSTEM_SETTING_TAB_VIEWS = [
  SYSTEM_SETTING_FORM_VIEW.CLAIMS,
  SYSTEM_SETTING_FORM_VIEW.DISPATCH,
  SYSTEM_SETTING_FORM_VIEW.INSIGHT,
  SYSTEM_SETTING_FORM_VIEW.APIKEY,
];

const DEFAULT_SYSTEM_SETTING_TAB_VIEWS_LOCATION = [
  SYSTEM_SETTING_FORM_VIEW.CLAIMS,
];

export {
  FORM_VIEW,
  SYSTEM_SETTING_FORM_VIEW,
  LOCATIONS_FORM_VIEW,
  DEFAULT_SYSTEM_SETTING_TAB_VIEWS,
  DEFAULT_SYSTEM_SETTING_TAB_VIEWS_LOCATION,
  AVAILABILITY_FORM_VIEW,
};
